export default __webpack_public_path__ + "static/media/html.30745ba0.png";